
import { Loader2 } from "lucide-react";
import { Progress } from "@/components/ui/progress";

interface LoadingStateWithProgressProps {
  message?: string;
  progress?: number;
}

export function LoadingStateWithProgress({ 
  message = "Loading...", 
  progress 
}: LoadingStateWithProgressProps) {
  return (
    <div className="flex flex-col items-center justify-center p-8 space-y-4">
      <Loader2 className="h-8 w-8 animate-spin" />
      <p className="text-muted-foreground">{message}</p>
      {progress !== undefined && (
        <Progress value={progress} className="h-2 w-full max-w-md" />
      )}
    </div>
  );
}
